import { SagaIterator } from "redux-saga";
import { call, put, takeLatest } from "redux-saga/effects";
import { IResponse } from "../../../../libs/requester/IResponse";
import { requester } from "../../../../libs/requester/requester-axios";
import { setLoading, setSingleAdvertData } from "../../repository/slice";

function* getSingleAdvertDataWorker({ payload }: any): SagaIterator {
    try {
        yield put(setLoading(true));
        const { data, message, isError }: IResponse<any> = yield call(requester.get, "/api/statistic/announcement/" + payload.id);
        if (isError) {

        } else {
            yield put(setSingleAdvertData(data));
        }
    } catch (error) {
        console.error("getSingleAdvertDataWorker: ", error);
    } finally {
        yield put(setLoading(false));
    };
};

export function* getSingleAdvertDataWatcher() {
    yield takeLatest("@saga/GET_SINGLE_ADVERT_DATA", getSingleAdvertDataWorker);
};